import axios from 'axios';
import { API } from '../api';
import axiosInstance from '../axiosConfig';
import { useAuthStore } from '../../zustand-store/auth.store';

export const loginApiDev = async ({ email, password }) => {
  const response = await axiosInstance.post(
    API.AUTH_DEV.LOGIN,
    { email, password },
    { withCredentials: true }
  );
  if (!response.data?.data?.accessToken) {
    return response;
  }
  const refreshToken = response.data.data.refreshToken;
  const accessToken = response.data.data.accessToken;
  const detailsProvided = response.data.data.detailsProvided;
  localStorage.setItem('token', refreshToken);
  useAuthStore.getState().setAccessToken(accessToken);
  useAuthStore.getState().setDetailsProvided(detailsProvided);
  return response.data;
};

export const loginApiProd = async ({ email, password }) => {
  const response = await axiosInstance.post(
    API.AUTH.LOGIN,
    { email, password },
    { withCredentials: true }
  );
  if (!response.data?.data?.accessToken) {
    return response;
  }
  const accessToken = response.data.data.accessToken;
  const detailsProvided = response.data.data.detailsProvided;
  if (accessToken) {
    useAuthStore.getState().setAccessToken(accessToken);
    useAuthStore.getState().setDetailsProvided(detailsProvided);
  }
  return response.data;
};

export const refreshTokenDev = async () => {
  const BASE_URL = import.meta.env.VITE_BASE_URL_BACKEND;
  const token = localStorage.getItem('token');

  // ✅ If no token, return null (don't call API)
  if (!token || token == 'undefined') {
    return null;
  }

  try {
    const response = await axios.post(BASE_URL + API.AUTH_DEV.REFRESH + token, {
      withCredentials: true
    });

    const accessToken = response.data?.data?.accessToken;
    const refreshToken = response.data?.data?.refreshToken;

    if (refreshToken) {
      localStorage.setItem('token', refreshToken);
    }

    if (accessToken) {
      await useAuthStore.getState().setAccessToken(accessToken);
    }

    return accessToken || null;
  } catch (error) {
    console.error('Failed to refresh token:', error);
    return null;
  }
};

// Session-aware refresh. The backend answers 200 even when the session is dead, with a plain
// string body ('Session Expired', 'Session not found', 'Invalid refresh token') instead of
// { data: { accessToken } } - so success is "an access token came back", not the HTTP status.
export const refreshTokenProd = async () => {
  const BASE_URL = import.meta.env.VITE_BASE_URL_BACKEND;
  try {
    // raw axios, not axiosInstance, so a failing refresh can't re-enter the 401 interceptor
    const response = await axios.post(BASE_URL + API.AUTH.REFRESH, null, {
      withCredentials: true
    });
    const accessToken = response?.data?.data?.accessToken;
    if (typeof accessToken !== 'string' || !accessToken) {
      return null;
    }
    useAuthStore.getState().setAccessToken(accessToken);
    return accessToken;
  } catch (error) {
    console.error('Failed to refresh token:', error);
    return null;
  }
};

export const logoutDev = async () => {
  localStorage.removeItem('token');
  useAuthStore.getState().clearAuth();
};

// Revokes the server-side session and clears the jid/sid cookies. Local auth state is cleared
// even if the call fails, so the user is never left half-logged-in.
export const logoutProd = async () => {
  const BASE_URL = import.meta.env.VITE_BASE_URL_BACKEND;
  try {
    await axios.post(BASE_URL + API.AUTH.LOGOUT, null, { withCredentials: true });
  } catch (error) {
    console.error('Failed to revoke session on logout:', error);
  } finally {
    useAuthStore.getState().clearAuth();
  }
};

export const verifyEmail = async (token) => {
  const response = await axiosInstance.get(API.AUTH.VERIFY + token);
  return response;
};
